(function (host) {
  "use strict";

  var KEY = "__brkoxBlackFridayCountdown";
  var SELECTOR = "[data-brkox-bf-countdown]";
  var MAX_DELAY = 2147483647;

  function parseInstant(value) {
    if (typeof value !== "string" || !/(?:Z|[+-]\d{2}:\d{2})$/.test(value)) return NaN;
    return Date.parse(value);
  }

  function remaining(now, start, end) {
    if (![now, start, end].every(Number.isFinite) || end <= start) return { phase: "invalid" };
    if (now < start) return { phase: "before", next: start - now };
    if (now >= end) return { phase: "ended" };
    var seconds = Math.ceil((end - now) / 1000);
    return {
      phase: "active",
      days: Math.floor(seconds / 86400),
      hours: Math.floor((seconds % 86400) / 3600),
      minutes: Math.floor((seconds % 3600) / 60),
      seconds: seconds % 60
    };
  }

  function install(windowObject) {
    if (windowObject[KEY]) {
      windowObject[KEY].init(windowObject.document);
      return windowObject[KEY];
    }

    var documentObject = windowObject.document;
    var records = new Map();
    var timeout = null;
    var units = ["days", "hours", "minutes", "seconds"];

    function clearTimer() {
      if (timeout !== null) windowObject.clearTimeout(timeout);
      timeout = null;
    }

    function refresh() {
      clearTimer();
      var now = windowObject.Date.now();
      var delay = Infinity;

      records.forEach(function (record, element) {
        if (!element.isConnected) {
          records.delete(element);
          return;
        }
        var state = remaining(now, record.start, record.end);
        if (state.phase !== "active") {
          element.hidden = true;
          if (state.phase === "before") delay = Math.min(delay, state.next + 10);
          return;
        }

        units.forEach(function (unit) {
          var value = String(state[unit]).padStart(2, "0");
          if (record.nodes[unit].textContent !== value) record.nodes[unit].textContent = value;
        });
        element.hidden = false;
        delay = Math.min(delay, 1020 - (now % 1000));
      });

      if (!documentObject.hidden && Number.isFinite(delay)) {
        timeout = windowObject.setTimeout(refresh, Math.min(delay, MAX_DELAY));
      }
    }

    function register(element) {
      if (records.has(element)) return;
      var nodes = {};
      var valid = units.every(function (unit) {
        nodes[unit] = element.querySelector('[data-bf-unit="' + unit + '"]');
        return Boolean(nodes[unit]);
      });
      if (!valid) {
        element.hidden = true;
        return;
      }
      records.set(element, {
        start: parseInstant(element.getAttribute("data-start")),
        end: parseInstant(element.getAttribute("data-end")),
        nodes: nodes
      });
    }

    function init(scope) {
      if (!scope) return;
      if (typeof scope.matches === "function" && scope.matches(SELECTOR)) register(scope);
      if (typeof scope.querySelectorAll === "function") scope.querySelectorAll(SELECTOR).forEach(register);
      refresh();
    }

    var api = { init: init, refresh: refresh };
    windowObject[KEY] = api;
    documentObject.addEventListener("shopify:section:load", function (event) { init(event.target); });
    documentObject.addEventListener("shopify:section:unload", function (event) {
      records.forEach(function (record, element) {
        if (event.target === element || event.target.contains(element)) records.delete(element);
      });
      refresh();
    });
    documentObject.addEventListener("visibilitychange", function () {
      if (documentObject.hidden) clearTimer();
      else refresh();
    });
    windowObject.addEventListener("pagehide", clearTimer);
    windowObject.addEventListener("pageshow", refresh);
    init(documentObject);
    return api;
  }

  if (typeof module === "object" && module.exports) {
    module.exports = { parseInstant: parseInstant, remaining: remaining, install: install };
  }
  if (host && host.document) install(host);
})(typeof window === "object" ? window : null);
